import { Nullable } from 'typescript-nullable';
import Partner from './partner';
import SlotName from '../common/slot-name';
import ScreenSize from '../common/screen-size';
import DeviceType from '../common/device-type';
import PageType from '../common/page-type';

export default class Nexx360 extends Partner {
    readonly bidder = 'nexx360';
    mapping = {
        [PageType.ResultsPage]: {
            [DeviceType.desktop]: {
                [ScreenSize.XXL]: {
                    [SlotName.integratedMpu]: 'wfkv8x6z',
                    [SlotName.rSkyT]: 'ywawjujv',
                    [SlotName.rSkyT2]: 'gr72fgwi',
                    [SlotName.tBanner]: '6ea72szd',
                    [SlotName.rSkyB]: 'eyt1lhr4',
                    [SlotName.rSkyB2]: 'uotuo9t4',
                    [SlotName.integratedListing]: '4mqvxnif',
                },
                [ScreenSize.XL]: {
                    [SlotName.integratedMpu]: 'wfkv8x6z',
                    [SlotName.rSkyT]: 'ywawjujv',
                    [SlotName.rSkyT2]: 'gr72fgwi',
                    [SlotName.tBanner]: '6ea72szd',
                    [SlotName.rSkyB]: 'eyt1lhr4',
                    [SlotName.rSkyB2]: 'uotuo9t4',
                    [SlotName.integratedListing]: '4mqvxnif',
                },
                [ScreenSize.L]: {
                    [SlotName.integratedMpu]: 'wfkv8x6z',
                    [SlotName.tBanner]: '6ea72szd',
                    [SlotName.integratedListing]: '4mqvxnif',
                },
            },
            [DeviceType.tablet]: {
                [ScreenSize.L]: {
                    [SlotName.integratedMpu]: 'utg53t43',
                    [SlotName.tBanner]: '9itrmvjw',
                    [SlotName.integratedListing]: 'w4rgubgf',
                },
                [ScreenSize.M]: {
                    [SlotName.integratedMpu]: 'utg53t43',
                    [SlotName.tBanner]: '9itrmvjw',
                    [SlotName.integratedListing]: 'w4rgubgf',
                },
            },
            [DeviceType.mobile]: {
                [ScreenSize.S]: {
                    [SlotName.integratedMpu]: '9dufd1yv',
                    [SlotName.integratedListing]: '1uellny9',
                    [SlotName.floatingFooter]: 'ilaz4jtf',
                },
                [ScreenSize.XS]: {
                    [SlotName.integratedMpu]: '9dufd1yv',
                    [SlotName.integratedListing]: '1uellny9',
                    [SlotName.floatingFooter]: 'ilaz4jtf',
                },
            },
        },
        [PageType.VIP]: {
            [DeviceType.desktop]: {
                [ScreenSize.XXL]: {
                    [SlotName.vipBanner]: 's9sd1cls',
                    [SlotName.mpu]: 'f3ps8spf',
                    [SlotName.vipMiddleDesktop]: 'q9lxqwvb',
                    [SlotName.galleryMPU]: 'pa3ts0k1',
                    [SlotName.galleryBanner]: 'xdbeztww',
                },
                [ScreenSize.XL]: {
                    [SlotName.vipBanner]: 's9sd1cls',
                    [SlotName.mpu]: 'f3ps8spf',
                    [SlotName.vipMiddleDesktop]: 'q9lxqwvb',
                    [SlotName.galleryMPU]: 'pa3ts0k1',
                    [SlotName.galleryBanner]: 'xdbeztww',
                },
                [ScreenSize.L]: {
                    [SlotName.vipBanner]: 's9sd1cls',
                    [SlotName.mpu]: 'f3ps8spf',
                    [SlotName.galleryMPU]: 'pa3ts0k1',
                    [SlotName.galleryBanner]: 'xdbeztww',
                },
            },
            [DeviceType.tablet]: {
                [ScreenSize.L]: {
                    [SlotName.vipBanner]: 'oq5c7uxq',
                    [SlotName.mpu]: 'jqijc7c6',
                    [SlotName.galleryMPU]: '93nd35e0',
                    [SlotName.galleryBanner]: '4i17zgnn',
                },
                [ScreenSize.M]: {
                  [SlotName.vipBanner]: 'oq5c7uxq',
                    [SlotName.mpu]: 'jqijc7c6',
                    [SlotName.galleryMPU]: '93nd35e0',
                    [SlotName.galleryBanner]: '4i17zgnn',
                },
            },
            [DeviceType.mobile]: {
                [ScreenSize.S]: {
                    [SlotName.floatingFooter]: '2zevr7y6',
                    [SlotName.vipMiddleMobile]: 'xlju1wjn',
                    [SlotName.galleryMPU]: 'vy9vwupl',
                    [SlotName.galleryBanner]: 'v10sk05n',
                },
                [ScreenSize.XS]: {
                    [SlotName.floatingFooter]: '2zevr7y6',
                    [SlotName.vipMiddleMobile]: 'xlju1wjn',
                    [SlotName.galleryMPU]: 'vy9vwupl',
                    [SlotName.galleryBanner]: 'v10sk05n',
                },
            },
        },
        [PageType.Homepage]: {
            [DeviceType.desktop]: {
                [ScreenSize.XXL]: {
                    [SlotName.homeSideAd]: 'd6kn8z9z',
                },
                [ScreenSize.XL]: {
                    [SlotName.homeSideAd]: 'd6kn8z9z',
                },
                [ScreenSize.L]: {
                    [SlotName.homeSideAd]: 'd6kn8z9z',
                },
            },
            [DeviceType.tablet]: {
                [ScreenSize.L]: {
                    [SlotName.homeSideAd]: 'f2feor0w',
                },
                [ScreenSize.M]: {
                    [SlotName.homeSideAd]: 'f2feor0w',
                },
            },
            [DeviceType.mobile]: {
                [ScreenSize.S]: {
                    [SlotName.homeBanner]: 'y9k5q3yq',
                },
                [ScreenSize.XS]: {
                    [SlotName.homeBanner]: 'y9k5q3yq',
                },
            },
        },
    };

    toObject() {
        if (Nullable.isNone(this.getPlacement())) {
            return undefined;
        }

        return {
            bidder: this.bidder,
            params: {
                tagId: this.getPlacement(),
            },
        };
    }
}
